import React from "react";
import { PROCESS } from "../mock";
import Reveal from "./Reveal";

const HowItWorks = () => {
  return (
    <section id="process" className="relative py-24 sm:py-28">
      <div className="max-w-6xl mx-auto px-5 sm:px-6">
        {/* Header */}
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="section-label">{PROCESS.label}</span>
          <h2 className="font-display font-800 text-white text-[2rem] sm:text-[2.9rem] leading-[1.05] mt-4 tracking-tight">
            {PROCESS.title}
          </h2>
          <p className="text-[#a49e92] text-[1rem] leading-relaxed mt-5">
            {PROCESS.subtitle}
          </p>
        </Reveal>

        {/* Cards */}
        <div className="grid md:grid-cols-3 gap-5 mt-14">
          {PROCESS.cards.map((card, i) => (
            <Reveal
              key={i}
              delay={i * 120}
              className="group relative flex flex-col rounded-[22px] border border-white/[0.08] bg-gradient-to-b from-white/[0.035] to-white/[0.01] p-7 hover:border-[#d69b4e]/30 transition-all duration-300 hover:-translate-y-1"
            >
              {/* number / tag row */}
              <div className="flex items-center justify-between mb-6">
                {card.num ? (
                  <span className="font-display font-700 text-[1.6rem] gold-text">{card.num}</span>
                ) : (
                  <span className="section-label !tracking-[0.24em] text-[#d69b4e]">{card.tag}</span>
                )}
                {card.num && card.tag && (
                  <span className="inline-flex items-center rounded-full border border-[#d69b4e]/30 bg-[#d69b4e]/[0.08] px-3 py-1 text-[0.7rem] font-semibold uppercase tracking-wider text-[#e8b876]">
                    {card.tag}
                  </span>
                )}
              </div>

              <h3 className="font-display font-700 text-white text-[1.3rem] leading-snug">
                {card.title}
              </h3>
              <p className="mt-4 leading-relaxed text-[0.94rem] flex-1 text-[#989286]">
                {card.body}
              </p>

              {card.cta && (
                <a
                  href={card.cta.href}
                  target={card.cta.href.startsWith("#") ? undefined : "_blank"}
                  rel={card.cta.href.startsWith("#") ? undefined : "noreferrer"}
                  className={`inline-flex items-center gap-2 rounded-full font-600 px-5 py-3 text-[0.9rem] mt-7 self-start transition-all duration-200 ${
                    card.cta.primary
                      ? "bg-white text-[#0a0908] hover:bg-[#f0ece3] hover:-translate-y-0.5 shadow-[0_8px_24px_-10px_rgba(255,255,255,0.4)]"
                      : "border border-white/15 bg-white/[0.03] text-white hover:bg-white/[0.08] hover:border-white/25"
                  }`}
                >
                  {card.cta.label} <span aria-hidden>→</span>
                </a>
              )}
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
